import { AxiosPromise } from 'axios'
import { baseURL, http } from '@/api/httpAxios'
import { User } from 'interfaces/user'

export default class UserAPI {
  public static getCurrentUser(
    reload = false
  ): AxiosPromise<{ user: User | null }> {
    const params = new URLSearchParams()
    if (reload) {
      params.append('reload', 'true')
    }
    return http.get('/auth/current-user', { params })
  }

  public static login(roles: string[]) {
    if (process.env.NODE_ENV === 'production') {
      window.location.href = `${baseURL}/auth`
    } else {
      // Dev
      const params = new URLSearchParams()

      if (roles && roles.length) {
        for (const role of roles) {
          params.append('roles', role)
        }
      } else {
        params.append('roles', '[]')
      }

      window.location.href = `${baseURL}/auth/dev?${params.toString()}`
    }
  }

  public static fakeUserLogin(userId: number) {
    window.location.href = `${baseURL}/auth/dev?userId=${userId}`
  }

  public static fakeUserLogout() {
    window.location.href = `${baseURL}/auth/dev`
  }

  public static changeUser(userId: number) {
    window.location.href = `${baseURL}/auth/dev?userId=${userId}`
  }
}
